'use client';
import React from 'react';
import LegalPageShell from '@/components/LegalPageShell';
import CookiePolicyContent from './components/CookiePolicyContent';

export default function CookiePolicyPage() {
  return (
    <LegalPageShell>
      <CookiePolicyContent />
    </LegalPageShell>
  );
}
